import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { observabilityApi, type TraceSpan } from '../../api/observability';

export function TraceViewerPage() {
  const [traces, setTraces] = useState<TraceSpan[]>([]);
  const [error, setError] = useState('');

  useEffect(() => {
    void observabilityApi.traces().then(setTraces).catch((e) => setError(String(e)));
  }, []);

  return (
    <div className="mx-auto max-w-5xl p-6">
      <Link to="/observability" className="text-sm text-slate-600 hover:underline dark:text-slate-400">← Operations Center</Link>
      <h1 className="mt-2 text-2xl font-semibold">Trace Viewer</h1>
      {error && <p className="mt-4 text-sm text-red-600">{error}</p>}
      <div className="mt-4 overflow-x-auto rounded-lg border dark:border-slate-700">
        <table className="w-full text-left text-sm">
          <thead className="border-b bg-slate-50 dark:border-slate-700 dark:bg-slate-800">
            <tr>
              <th className="px-4 py-2">Service</th>
              <th className="px-4 py-2">Operation</th>
              <th className="px-4 py-2">Type</th>
              <th className="px-4 py-2">Duration</th>
              <th className="px-4 py-2">Trace ID</th>
            </tr>
          </thead>
          <tbody>
            {traces.map((t) => (
              <tr key={t.id} className="border-b dark:border-slate-800">
                <td className="px-4 py-2">{t.service}</td>
                <td className="px-4 py-2">{t.operation}</td>
                <td className="px-4 py-2">{t.type}</td>
                <td className="px-4 py-2">{t.duration_ms}ms</td>
                <td className="px-4 py-2 font-mono text-xs">{t.trace_id.slice(0, 12)}…</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
